import { useAtom } from "jotai";
import { historicoAtom, loadingAtom, anioFiltroAtom, filtroColaboradorAtom, filtroSubsidioAtom } from "../DescansoMedicoStore";
import { HistoricoDescansoMedicoService } from "services/VacacionesService";

const useListarHistoricoDescansoMedico = () => {
  const [historico, setHistorico] = useAtom(historicoAtom);
  const [loading, setLoading] = useAtom(loadingAtom);
  const [anioFiltro, setAnioFiltro] = useAtom(anioFiltroAtom);
  const [filtroColaborador, setFiltroColaborador] = useAtom(filtroColaboradorAtom);
  const [filtroSubsidio, setFiltroSubsidio] = useAtom(filtroSubsidioAtom);

  const listar = async (anio) => {
    try {
      setLoading(true);
      const params = anio ? { anio } : {};
      const respuesta = await HistoricoDescansoMedicoService.resumen(params);
      if (respuesta.estado === "EXITO") {
        setHistorico(respuesta.data || []);
      }
    } catch (error) {
      console.error("Error al listar histórico DM", error);
    } finally {
      setLoading(false);
    }
  };

  const onCambiarAnio = (anio) => {
    setAnioFiltro(anio);
    setFiltroColaborador(undefined);
    setFiltroSubsidio(undefined);
    listar(anio);
  };

  const onCambiarColaborador = (colaboradorNumeroDocumentoIdentidad) => {
    setFiltroColaborador(colaboradorNumeroDocumentoIdentidad);
  };

  const onCambiarSubsidio = (subsidio) => {
    setFiltroSubsidio(subsidio);
  };

  const historicoFiltrado = historico
    .filter((h) => !filtroColaborador || h.colaboradorNumeroDocumentoIdentidad === filtroColaborador)
    .filter((h) => filtroSubsidio === undefined || h.enSubsidio === filtroSubsidio);

  return {
    historico,
    historicoFiltrado,
    loading,
    anioFiltro,
    filtroColaborador,
    filtroSubsidio,
    listar,
    onCambiarAnio,
    onCambiarColaborador,
    onCambiarSubsidio,
  };
};

export default useListarHistoricoDescansoMedico;
